export default Buffer.from("A+BSQ29weXJpZ2h0IDE5OTAtMjAwOSBBZG9iZSBTeXN0ZW1zIEluY29ycG9yYXRlZC4KQWxsIHJpZ2h0cyByZXNlcnZlZC4KU2VlIC4vTElDRU5TReELRVRlbm1zLUI1LUhBBqFL6k4AgdNDCYMUAYJ9AYHUaAECYQyhXQGBAgIBgQYCAYEKAgGBDgIBgRICAYEWAgGBGgIBgR4CAYECIgGBBgABgQrKPwHuEQ==", "base64")


//////////////////
// WEBPACK FOOTER
// ./~/vue-pdf-signature/src/buffer-loader.js!./~/pdfjs-dist-sign/cmaps/ETenms-B5-V.bcmap
// module id = 628
// module chunks = 502